/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const installmentReportsService = {
  getListInstallmentStatus: (currency_pid: any, params: any) =>
    request.get(`/report/installment/total/${currency_pid}`, { params }),
  getListInstallmentClient: (currency_pid: any, params: any) =>
    request.get(`/report/installment/client/${currency_pid}`, { params }),
  getListInstallmentMonthly: (params: any) =>
    request.get(`/report/installment/monthly-payment`, { params }),
  updateInstallmentItem: (id: any, data: any) =>
    request.put(`/installment-item/${id}`, data)
};

export default installmentReportsService;
